import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'

const tones = {
  info: 'bg-info text-info-foreground',
  success: 'bg-success text-success-foreground',
  warning: 'bg-warning text-warning-foreground',
  danger: 'bg-danger text-danger-foreground',
}
export function Alert({
  className,
  tone = 'danger',
  appearance = 'banner',
  announcement = 'assertive',
  ...props
}: ComponentProps<'div'> & {
  tone?: keyof typeof tones
  appearance?: 'inline' | 'banner'
  announcement?: 'none' | 'polite' | 'assertive'
}) {
  return (
    <div
      {...props}
      data-slot="alert"
      role={
        announcement === 'assertive' ? 'alert' : announcement === 'polite' ? 'status' : undefined
      }
      className={cn(
        'text-sm leading-6',
        tones[tone],
        appearance === 'banner' ? 'rounded-control px-4 py-3' : 'bg-transparent',
        className,
      )}
    />
  )
}
export function AlertTitle({ className, ...props }: ComponentProps<'p'>) {
  return <p {...props} className={cn('font-semibold', className)} />
}
export function AlertDescription({ className, ...props }: ComponentProps<'div'>) {
  return <div {...props} className={cn('text-sm', className)} />
}
export function AlertActions({ className, ...props }: ComponentProps<'div'>) {
  return <div {...props} className={cn('mt-3 flex flex-wrap gap-2', className)} />
}
